/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AIInteractionFeedbackSchema = {
    rating: AIInteractionFeedbackSchema.rating;
    feedback_text?: (string | null);
};
export namespace AIInteractionFeedbackSchema {
    export enum rating {
        THUMBS_UP = 'thumbs_up',
        THUMBS_DOWN = 'thumbs_down',
        NEUTRAL = 'neutral',
    }
}

